import { query, mutation } from "../../api";

/**
 * Check PAN Status via KRA
 */
export async function checkPanStatus(panNo, dob = "", fetchType = "I", mobile = "") {
  try {
    const params = {
      pan_no: panNo,
      dob: dob,
      fetch_type: fetchType,
      mobile: mobile,
    };
    const response = await query(
      "check_pan_status",
      params,
      `statusCode kraStatusCode statusDescription panNumber name isKRAVerified details`,
      "digio"
    );
    return response?.data?.check_pan_status || null;
  } catch (error) {
    console.error("checkPanStatus API error:", error);
    return {
      statusCode: "ERROR",
      isKRAVerified: false,
      statusDescription: error.message || "KRA check failed",
    };
  }
}

/**
 * Fetch KRA Details (autofill data)
 */
export async function fetchKraDetails(panNo, dob = "", fetchType = "I", mobile = "") {
  try {
    const params = {
      pan_no: panNo,
      dob: dob,
      fetch_type: fetchType,
      mobile: mobile,
    };
    const response = await query(
      "fetch_kra_details",
      params,
      `status message data`,
      "digio"
    );
    return response?.data?.fetch_kra_details || null;
  } catch (error) {
    console.error("fetchKraDetails API error:", error);
    return {
      status: false,
      message: error.message || "Failed to fetch KRA details",
    };
  }
}

/**
 * Upload Registration Details to KRA (manual fallback flow)
 */
export async function uploadKraDetails(registrationReq = {}, serviceProvider = "NDML") {
  try {
    const params = {
      service_provider: serviceProvider,
      common_kra_registration_request: JSON.stringify(registrationReq),
    };
    const response = await mutation(
      "upload_kra_details",
      params,
      `status message reference_id`,
      "digio"
    );
    return response?.data?.upload_kra_details || null;
  } catch (error) {
    console.error("uploadKraDetails API error:", error);
    return {
      status: false,
      message: error.message || "Failed to upload KRA registration details",
    };
  }
}
